// ./widget-toolbar/toolbar.js

import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import WidgetToolbarRepository from "@ckeditor/ckeditor5-widget/src/widgettoolbarrepository";
import { getSelectedWidget } from '../util';
import flowVariableEdit from "./main";
import {
  COMMAND_NAME_EDIT,BALLOONCLASSNAME
} from "../constant";

export default class ImageWidgetToolbar extends Plugin {
  static get requires() {
    return [WidgetToolbarRepository, flowVariableEdit];
  }

  static get pluginName() {
    return "FlowEditToolbar";
  }

  afterInit() {
    const editor = this.editor;
    const widgetToolbarRepository = editor.plugins.get(WidgetToolbarRepository);

    // COMMAND_NAME_EDIT --> "ck-image-toolbar"
    widgetToolbarRepository.register(COMMAND_NAME_EDIT, {
      items: [flowVariableEdit.pluginName],
      getRelatedElement: getSelectedWidget,
      BALLOONCLASSNAME:BALLOONCLASSNAME
    });
  }
}
